import { render, staticRenderFns } from "./imgNtext.vue?vue&type=template&id=3bde5508&scoped=true&"
import script from "./imgNtext.vue?vue&type=script&lang=js&"
export * from "./imgNtext.vue?vue&type=script&lang=js&"
import style0 from "./imgNtext.vue?vue&type=style&index=0&id=3bde5508&prod&lang=scss&"
import style1 from "./imgNtext.vue?vue&type=style&index=1&id=3bde5508&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bde5508",
  null
  
)

export default component.exports